import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Button from 'fuse-ui/components/Button';

const styles = theme => ( {
    actionButton: {
        marginLeft: theme.spacing.unit * 3,
        marginRight: 0,
        textTransform: 'none'
    },
} );

const ActionButton = ( { buttonRef, children, classes, dataId, onClick } ) => {
    return (
        <Button
            buttonRef={buttonRef}
            className={classes.actionButton}
            data-automation-id={dataId}
            onClick={onClick}
            variant="text"
        >
            {
                React.Children.map( children, ( child ) => child )
            }
        </Button>
    );
};

ActionButton.propTypes = {
    buttonRef: PropTypes.object,
    children: PropTypes.node,
    classes: PropTypes.object.isRequired,
    dataId: PropTypes.string,
    onClick: PropTypes.func.isRequired,
};

export default withStyles( styles )( ActionButton );
